module.exports = __webpack_public_path__ + "img/place-mobile.25328d9f.gif";